import React from "react";
import NewsletterSeven from "../component/NewsletterSeven";

function NewsletterSevenContainers() {
  return <NewsletterSeven />;
}

export default NewsletterSevenContainers;
